<template>
    <div class="cp-question">

        <div class="content">
            <div class="question">
              <div class="question-title">
                <span v-if="data.required == 1" class="mark">*</span>
                <div class="seq">{{sort < 10 ? '0' + sort : sort}}</div>
                <span>{{data.subject}}</span>
              </div>
              <span v-if="(data.qtype == 3 || data.qtype == 307) && parseInt(data.alength)">&nbsp;({{data.alength}}个字符以内)</span>
              <span v-if="/^2/.test(data.qtype) && data.minnum != data.maxnum">&nbsp;({{ isEn ? (parseInt(data.maxnum) === (data.options && data.options.length) ? 'Select all that apply' : `Select up to ${data.maxnum} options.`) : `请选择${data.minnum}~${data.maxnum}项` }})</span>
              <span v-if="/^2/.test(data.qtype) && data.minnum == data.maxnum">&nbsp;(请选择{{data.minnum}}项)</span>
            </div>
            <div class="options-container">
                <div v-if="/^[1|2|4]/.test(data.qtype)">
                    <div
                        :class="['options', item.selected ? 'selected' : '']"
                        v-for="(item, index) in data.options"
                        @click="itemOnClick(index)"
                        :key="index"
                        :style="{backgroundColor: optionColor ? optionColor : ''}"
                    >
                        <div class="selector"
                            :class="{'selected': item.selected, 'selector-2': data.qtype == 2, 'selector-1': /^[1|4]/.test(data.qtype)}"
                            :style="{borderColor: item.selected && optionHighlightColor ? optionHighlightColor : ''}"
                        >
                            <div class="selector-center"
                                v-if="item.selected"
                                :style="{
                                    borderColor: item.selected && optionHighlightColor ? optionHighlightColor : '',
                                    backgroundColor: data.qtype == 2 ? '' : item.selected && optionHighlightColor ? optionHighlightColor : ''
                                }"
                            ></div>
                        </div>
                        <span>{{item.content}}</span>
                        <input
                            class="input"
                            v-if="item.remark == 1"
                            type="text"
                            :disabled="!item.selected"
                            v-model="item.text"
                            @change="updateItemContent(index)"
                            @click="onclick($event)">
                        <span v-if="item.selected && item.content_required == 1" style="color: red">*</span>
                    </div>
                </div>
                <!-- 矩阵打分 -->
                <div class="matrix_item" v-for="(row, dIndex) in data.rows" :key="dIndex">
                    <div class="question-subtitle">
                        {{row.content}}
                    </div>
                    <div class="checkbtn-group">
                      <div
                        :class="['checkbtn', row.val === oIndex ? 'selected' : '']"
                        v-for="(item, oIndex) in data.options"
                        @click="itemOnClick(oIndex, dIndex)"
                        :key="oIndex"
                        :style="{position: 'relative', backgroundColor: optionColor ? optionColor : ''}"
                      >
                        <div class="checkbtn-content">
                          <span>{{item.content}}</span>
                        </div>
                      </div>
                    </div>
                </div>

                <!-- 填空题 -->
                <div class="options"
                    v-if="data.qtype == 3 || data.qtype == 307"
                    :class="['textarea', data.selected ? 'selected' : '']"
                    @click="itemOnClick()"
                    :style="{backgroundColor: optionColor ? optionColor : ''}"
                >
                    <textarea
                        :style="{color: textColor}"
                        :placeholder="'请输入'"
                        class="options-input"
                        :rows="data.rowsnum"
                        v-model="data.content"
                        @change="updateContent"
                    >
                    </textarea>
                </div>
                <div v-if="data.qtype == 5" class="ShowImgCon">
                    <div class="simg"
                        :class="{'checked': item.selected}"
                        v-for="(item, index) in data.options"
                        :key="index"
                        @click="itemOnClick(index)">
                        <div class="simgbox" :style="{backgroundImage: 'url(' + item.pic + ')'}">
                        </div>
                        <div class="optionImg">
                            <div class="optionImg_wrap">
                                <div class="selector selector-1"
                                    :class="{'selected': item.selected}"
                                    :style="{borderColor: item.selected && optionHighlightColor ? optionHighlightColor : '#4483c1'}"
                                >
                                    <div class="selector-center"
                                        v-if="item.selected"
                                        :style="{
                                            borderColor: item.selected && optionHighlightColor ? optionHighlightColor : '#4483c1',
                                            backgroundColor: item.selected && optionHighlightColor ? optionHighlightColor : '#4483c1'
                                        }"
                                    ></div>
                                </div>
                                <div class="img_txt">{{item.content}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <select-address v-if="data.qtype == 305" v-on:citySelected="citySelected"></select-address>
            </div>
        </div>
    </div>
</template>

<script>
  import selectAddress from '~/components/selectAddress.vue';

  export default{
    components: {
        selectAddress
    },
    props: ['data', 'sort', 'optionHighlightColor', 'optionColor', 'textColor', 'isEn'],
    beforeMount(){

    },
    methods: {
      /**
       * 跳转其他页面
       * @param name
       * @param params
       */
      itemOnClick(oIndex, dIndex){
        let toSent = {
            qid: this.data.qid,
            qtype: this.data.qtype
        };
        if(oIndex >= 0) {
            toSent.index = oIndex;
            toSent.text = this.data.options[oIndex].text;
        }
        if(dIndex >= 0) {
            toSent.dIndex = dIndex;
        }
        console.log(toSent);
        this.$emit('itemClick', toSent);
      },
      citySelected(val) {
          this.data.content = val;
          this.updateContent();
      },
      onclick(e) {
          e.stopPropagation();
      },
      updateItemContent(index) {
        let toSent = {
            qid: this.data.qid,
            qtype: this.data.qtype
        };
        if(index >= 0) {
            toSent.index = index;
            toSent.text = this.data.options[index].text;
        }
        this.$emit('itemContentUpdate', toSent);
      },
      updateContent() {
        let toSent = {
            qid: this.data.qid,
            content: this.data.content
        };
        this.$emit('contentUpdate', toSent);
      }
    },
    mounted(){
    //   console.log(this.props);
    }
  }
</script>

<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
.cp-question
    width calc(100% - 0.44rem)
    margin 0.17rem 0.22rem 0
    background #ffffff
    border-radius 0.13rem
    .content
        font-size 0.22rem
        padding 0 20px
        .matrix_item
          padding-top 25px
          margin-bottom 25px;
          border-top 1px solid #d9d9d9
          .checkbtn-group
            display flex
            flex-wrap wrap
            .checkbtn
              position: relative;
              display: block;
              float: left;
              padding-left: 3px;
              margin-top: 3px;
              box-sizing: border-box;
              width 33.333%
              height 40px
              color: #000;
              line-height 40px
              text-align center
              padding-left 3px
              &.selected
                .checkbtn-content
                  background-color: rgba(35, 120, 255, 1);
                  color: #fff;
              &-content
                width 100%
                height 100%
                border-radius: 4px;
                background-color: rgba(0, 0, 0, 0.1);
          .question-subtitle
            margin-bottom: 11px;
            font-weight: normal;
            font-size: 16px;
            color: #000;
        .question
            width 100%
            // color #484848
            padding: 35px 20px 25px;
            font-size: 18px;
            position relative
            &-title
              position: relative;
              font-weight: normal;
              word-wrap: break-word;
              word-break: break-word;
              outline: 0;
            .seq
              display: block;
              margin-right: 8px;
              font-size: 18px;
              float: left;
            .mark
              color red
              position: absolute;
              left: -12px;
              top: 1px;
              background-size: 100%;
              vertical-align: -2px;
            .multi
                color white
                font-size 0.20rem
        .ShowImgCon
            .simg
                display: inline-block;
                width: 47.6%;
                background-color: #ffffff;
                border-radius: 0.04rem;
                overflow: hidden;
                vertical-align: top;
                border: solid 0.01rem #dde5ed;
                margin-bottom: 0.20rem;
                &:nth-child(odd)
                    margin-right: 0.15rem;
                &.checked
                    background-color: rgba(38,114,255,0.2);
                    box-shadow: 0 0.02rem 0.04rem 0 rgba(38,114,255,0.2);
                    animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
                    -webkit-animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
                    .optionImg
                        border-bottom-left-radius: 0.04rem;
                        border-bottom-right-radius: 0.04rem;
                .simgbox
                    margin: 0 auto;
                    border-top-left-radius: 0.04rem;
                    border-top-right-radius: 0.04rem;
                    position: relative;
                    width: 100%;
                    padding-top 100%;
                    background-size contain
                    background-position center center
                    background-repeat no-repeat

                .optionImg
                    padding: 0.14rem 0.10rem 0.14rem 20px;
                    position: relative;
                    .img_txt
                        font-size: 0.22rem;
                        // color #484848;
                        word-wrap: break-word;
                    .ico_radio
                        top: 50%;
                        left: 0.10rem;
                        border-radius: 50%;
        .options
            width 100%
            // height 0.60rem
            // color #484848
            line-height 24px;
            padding: 15px 20px;
            position relative
            font-size 16px
            border-top 1px solid #d9d9d9
            &.textarea
                height auto
            &-input
              font-size 16px;
              height: 6.25em;
              line-height: 1.78;
              position: relative;
              display: block;
              width: 100%;
              box-sizing: border-box;
              color: inherit;
              border-color: rgba(0, 0, 0, 0.2);
            &.selected
                animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
                -webkit-animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
            .input
                border-bottom: 0.01rem solid #333
                width: 3.90rem
                font-size: 0.22rem
                height: 0.32rem
                line-height 0.32rem
                padding-left: 0.10rem;
                margin-left 0.10rem;
    .selector
        float: left;
        display: inline-block;
        width: 1.25em;
        height: 1.25em;
        margin-right: 10px;
        box-sizing: border-box;
        border-radius: 100%;
        border: 1px solid #cbd5de;
        margin-top: 2px;
        transition: all 0.2s;
        flex-shrink: 0;
        &-2
          border-radius: 0.02rem
          .selector-center
              display: inline-block;
              width: 7px;
              height: 14px;
              border-right-style: solid;
              border-bottom-style: solid;
              border-right-width: 3px;
              border-bottom-width: 3px;
              transform: rotate(45deg);
              transform-origin: 90% 90%;
              vertical-align: top;
              border-color: rgb(38,114,255);
              margin-left: 1px
          &.selected
            border-color: rgb(38,114,255);
        &-1
          border-radius: 50%
          &.selected
            border: solid 0.3125em #018fff;

    @keyframes buttonSelected {
        0% {
            transform: translateY(0);
        }
        40% {
            transform: translateY(-0.03rem);
        }
        100% {
            transform: translateY(0);
        }
    }

</style>
